import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectCurrentUser } from '../store/user/selectors/user.selectors';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuardService implements CanActivate {
  protected store = inject(Store);
  protected router = inject(Router);
  protected log = inject(LoggerService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    return this.store.select(selectCurrentUser).pipe(
      map((user) => {
        this.log.debug(` Auth Login User ${!!user}`);
        if (!!user) {
          return this.router.createUrlTree(['/dashboard']);
        }
        return true;
      }),
    );
  }
}

// canAtivate (store: Store, router: Router) {
//   return this.store.select(selectIsLoading).pipe(
//     skipWhile((isLoading) => isLoading),
//     take(1),
//     switchMap(() => store.select(selectIsAuthenticated)),
//     map((isAuthenticated) => {
//       if ( isAuthenticated ) {
//         return true;
//       }
//       return router.createUrlTree([ '/login' ]);
//     })
//   );
// }
